import styles from './CssSelectorEditor.css';
import React, { Component, PropTypes } from 'react';
// import { debounce } from 'utils/underscore_cust';

const Messages = {
  CUSTOM_SELECTOR: 'Customize CSS Selector',
  RESET: 'reset',
  INVALID: 'The syntax of the selector is not valid or not supported',
  CALL_SUPPORT: `The current CSS selector is resource-intensive.
    For improved performance, please use a shorter selector.
    Thank you for your understanding. If you need help, please reach out to our support team.`
};

export default class CssSelectorEditor extends Component {
  static propTypes = {
    event: PropTypes.object,
    cssSelector: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onReset: PropTypes.func,
    originEditedEvent: PropTypes.object
  };

  constructor (props) {
    super(props);
    this.message = null;
    this.state = {
      expanded: true,
      valid: null
    };
  }

  cssValueGenerator = () => {
    const {event, originEditedEvent} = this.props;
    if (originEditedEvent &&
        event.attrs.id === originEditedEvent.attrs.id &&
        event.attrs.definitionType === originEditedEvent.attrs.definitionType &&
        event.attrs.content !== originEditedEvent.attrs.content) {
      return originEditedEvent.attrs.content;
    } else {
      return event.attrs.content;
    }
  }

  render () {
    let {valid, state={}} = this.props.event;
    let {error} = state;
    let value = this.cssValueGenerator();
    return (
      <div className={styles.mainContainer}>
        <div
          ref='message'
          className={styles.container}>
          <a className={styles.title} onClick={this.handleShowHideEditor}>
            {Messages.CUSTOM_SELECTOR}
          </a>
          {
          this.state.expanded && !this.props.disabled &&
            <a
              className={styles.reset}
              onClick={this.handleResetCssSelector}>
              {Messages.RESET}
            </a>
          }
        </div>
        <div>
        {
          this.state.expanded &&
            <textarea
              ref='textarea'
              className={styles.customSelector}
              data-valid={this.props.event.valid}
              onBlur={this.validate}
              onChange={this.handleUpdateCssSelector}
              readOnly={this.props.disabled}
              value={value}
            />
        }
        {
          !valid &&
            <div className={styles.error}>{Messages[error] || Messages.INVALID}</div>
        }
        </div>
      </div>
    );
  }

  handleShowHideEditor = () => {
    if (!this.props.event.valid) {
      this.setState({expanded: true});
      return;
    }
    this.setState({expanded: !this.state.expanded});
  };

  // handleUpdateCssSelector = debounce((e) => {
  //   let selector = this.refs.textarea.value;
  //   console.log(2, selector, e)
  //   this.setState({value: selector});
  //   this.props.onChange(selector);
  // }, 1000);

  handleUpdateCssSelector = e => {
    let selector = this.refs.textarea.value;
    this.setState({value: selector});
    this.props.onChange(selector);
  };

  handleResetCssSelector = () => {
    let selector = this.props.event.origCssSelector;
    if (selector) {
      this.refs.textarea.value = selector;
      this.props.onChange(selector);
    }
  };

  validate = (e) => {
    // let selector = e.target.value;
    return false;
  };

  getCSSSelector () {
    return this.state.cssSelector || this.props.cssSelector;
  };
}



/** WEBPACK FOOTER **
 ** ./src/views/widgets/cssSelectorEditor/CssSelectorEditor.js
 **/